import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Div } from 'Common/components/Atoms/Div';
import { Flex } from 'Common/components/Atoms/Flex';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { Text } from 'Common/components/Atoms/Text';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

const steps = [
  {
    label: 'Enable 2FA',
    content: 'All reviewers are required to enable two-factor authentication.',
  },
  {
    label: 'Join Our Slack Workspace',
    content: 'Join the PullRequest Reviewer Slack workspace',
  },
  {
    label: 'Review your settings',
    content: 'Review your skills and reviewer display name',
  },
];

export function Stepper({ step }: { step: number }): JSX.Element {
  const theme = useTheme();
  return (
    <Flex direction="column" width="75%" mt={4}>
      {steps.map((item, i) => (
        <Flex
          className="step"
          key={item.label}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Flex
            height={40}
            width={40}
            justifyContent="center"
            alignItems="center"
            background={
              i === step
                ? theme.palette.secondary.main
                : step > i
                ? 'transparent'
                : theme.palette.action.disabledBackground
            }
            border={
              step > i ? `solid 2px ${theme.palette.secondary.main}` : 'none'
            }
            mb={3}
            borderRadius="50%"
            boxSizing="border-box"
          >
            <Text variant="body1" color={theme.palette.common.white}>
              {step > i ? (
                <FontIcon icon={faCheck} color={theme.palette.secondary.main} />
              ) : (
                i + 1
              )}
            </Text>
          </Flex>
          <Text
            variant="h4"
            textAlign="center"
            color={
              step === i ? theme.palette.text.primary : theme.palette.grey[400]
            }
          >
            {item.label}
          </Text>
          {step === i && (
            <Text variant="body1" mt={3} textAlign="center">
              {item.content}
            </Text>
          )}
          {i < steps.length - 1 && (
            <Div
              borderLeft={`solid 1px ${theme.palette.grey[300]}`}
              width={0}
              height={30}
              my={1}
            />
          )}
        </Flex>
      ))}
    </Flex>
  );
}

export default Stepper;
